import React from "react";
import MinimalistResumeTemplate from "../templates/MinimalistPremiumTemplate";
import CreativeResumeTemplate from "../templates/CreativePremiumTemplate";
import ResumePreview from "../ResumePreview"; // The original ExecutiveTemplate preview

const ResumePreviewContainer = ({ resumeData, selectedTemplate }) => {
  // Render different preview components based on selected template
  const renderPreview = () => {
    const previewProps = {
      resumeData,
      selectedTemplate,
    };

    switch (selectedTemplate) {
      case "minimalist":
        return <MinimalistPreview {...previewProps} />;
      case "creative":
        return <CreativePreview {...previewProps} />;
      case "executive":
      default:
        return <ResumePreview resumeData={resumeData} />;
    }
  };

  return renderPreview();
};

// Minimalist Preview Component
const MinimalistPreview = ({ resumeData }) => {
  return (
    <div className="resume-preview-container">
      <div className="preview-header">
        <h2 className="preview-title">Minimalist Modern Preview</h2>
      </div>

      <div className="preview-content">
        <div className="resume-paper">
          <MinimalistResumeTemplate data={resumeData} />
        </div>
      </div>
    </div>
  );
};

// Creative Preview Component
const CreativePreview = ({ resumeData }) => {
  return (
    <div className="resume-preview-container">
      <div className="preview-header">
        <h2 className="preview-title">Creative Bold Preview</h2>
      </div>

      <div className="preview-content">
        <div className="resume-paper">
          <CreativeResumeTemplate data={resumeData} />
        </div>
      </div>
    </div>
  );
};

export default ResumePreviewContainer;
